import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full flex flex-col md:flex-row" }
const _hoisted_2 = { class: "w-full flex flex-col" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "flex flex-wrap -mx-1" }
const _hoisted_5 = { class: "w-full flex flex-row gap-x-2" }
const _hoisted_6 = {
  key: 0,
  class: "w-full flex flex-col"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "flex flex-wrap -mx-1 mt-3" }
const _hoisted_9 = { class: "relative p-2 w-full h-full bg-gray-50 shadow-xl border border-gray-200 rounded-lg cursor-pointer hover:bg-gray-200 group" }
const _hoisted_10 = { class: "grid grid-cols-4 gap-2" }
const _hoisted_11 = { class: "w-full aspect-square overflow-hidden rounded-lg border border-gray-300 col-span-1" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "flex flex-col w-full flex-grow flex-1 col-span-3 justify-center" }
const _hoisted_14 = { class: "font-semibold line-clamp-1 text-sm" }
const _hoisted_15 = { class: "text-gray-600 text-xs" }
const _hoisted_16 = { class: "text-gray-600 text-xs" }
const _hoisted_17 = { class: "text-gray-600 text-xs" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-3 text-sm" }
const _hoisted_21 = { class: "p-3 w-full h-full bg-gray-50 shadow-xl border border-gray-200 rounded-md text-center flex flex-col" }
const _hoisted_22 = { class: "flex flex-col w-full flex-grow flex-1" }
const _hoisted_23 = { class: "w-full aspect-square overflow-hidden rounded-lg border border-gray-300" }
const _hoisted_24 = ["src"]
const _hoisted_25 = { class: "py-2" }
const _hoisted_26 = { class: "font-semibold line-clamp-1" }
const _hoisted_27 = { class: "text-gray-600 text-sm line-clamp-1" }
const _hoisted_28 = { class: "text-gray-600 text-sm line-clamp-1" }
const _hoisted_29 = { class: "text-gray-600 text-sm line-clamp-1" }
const _hoisted_30 = { class: "text-gray-600 text-sm line-clamp-1" }
const _hoisted_31 = { class: "w-full flex flex-col mt-auto" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = {
  key: 1,
  class: "w-full flex flex-col"
}
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { class: "flex flex-wrap -mx-1 mt-3" }
const _hoisted_36 = { class: "relative p-2 w-full h-full bg-gray-50 shadow-xl border border-gray-200 rounded-lg cursor-pointer hover:bg-gray-200 group" }
const _hoisted_37 = { class: "grid grid-cols-4 gap-2" }
const _hoisted_38 = { class: "w-full aspect-square overflow-hidden rounded-lg border border-gray-300 col-span-1" }
const _hoisted_39 = ["src"]
const _hoisted_40 = { class: "flex flex-col w-full flex-grow flex-1 col-span-3 justify-center" }
const _hoisted_41 = { class: "font-semibold line-clamp-1 text-sm" }
const _hoisted_42 = { class: "text-gray-600 text-xs line-clamp-2" }
const _hoisted_43 = ["onClick"]
const _hoisted_44 = { key: 1 }
const _hoisted_45 = { class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-3 text-sm" }
const _hoisted_46 = { class: "p-3 w-full h-full bg-gray-50 shadow-xl border border-gray-200 rounded-md text-center flex flex-col" }
const _hoisted_47 = { class: "flex flex-col w-full flex-grow flex-1" }
const _hoisted_48 = { class: "w-full aspect-square overflow-hidden rounded-lg border border-gray-300" }
const _hoisted_49 = ["src"]
const _hoisted_50 = { class: "py-2" }
const _hoisted_51 = { class: "font-semibold line-clamp-1" }
const _hoisted_52 = { class: "text-gray-600 text-sm line-clamp-4" }
const _hoisted_53 = { class: "w-full flex flex-col mt-auto" }
const _hoisted_54 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Field = _resolveComponent("Field")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InputGroup = _resolveComponent("InputGroup")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_ToggleSwitch = _resolveComponent("ToggleSwitch")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_DataView = _resolveComponent("DataView")!
  const _component_BlockUI = _resolveComponent("BlockUI")!
  const _component_CatalogoDetalleView = _resolveComponent("CatalogoDetalleView")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["block w-full space-y-2", { 'p-5': _ctx.padding }])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_Field, {
          name: "tipo",
          modelValue: _ctx.tipo,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tipo) = $event))
        }, {
          default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
            _createVNode(_component_Dropdown, {
              onBlur: handleBlur,
              "onUpdate:modelValue": handleChange,
              "model-value": value,
              placeholder: "Buscar por...",
              class: _normalizeClass(["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0}]),
              options: _ctx.tipos,
              optionLabel: "descripcion"
            }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options", "class"])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_InputGroup, { class: "flex-grow ml-0 md:ml-2 mt-2 md:mt-0" }, {
          default: _withCtx(() => [
            _createVNode(_component_InputText, {
              onKeyup: _ctx.filtrar,
              modelValue: _ctx.filtroTexto,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filtroTexto) = $event)),
              placeholder: "Buscar...",
              class: "input-base no-rounded-right"
            }, null, 8, ["onKeyup", "modelValue"]),
            _createVNode(_component_Button, {
              onClick: _ctx.limpiarFiltro,
              icon: "pi pi-times",
              class: "border borde-red-700 bg-red-700 text-white no-rounded-left hover:bg-transparent hover:text-red-700 hover:border-red-700"
            }, null, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_2, [
        (_ctx.tags)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tags, (tag) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: tag.id,
                    class: "w-full md:w-1/2 lg:w-1/4 px-1 pb-2"
                  }, [
                    _createVNode(_component_Field, {
                      name: `tag-${tag.id}`
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_MultiSelect, {
                          "model-value": tag.opcionesTagSeleccionados,
                          "onUpdate:modelValue": val => { tag.opcionesTagSeleccionados = val; _ctx.filtrar(); },
                          options: tag.opciones,
                          optionLabel: "descripcion",
                          optionValue: "id",
                          filter: "",
                          placeholder: tag.descripcion,
                          class: "input-base"
                        }, null, 8, ["model-value", "onUpdate:modelValue", "options", "placeholder"])
                      ]),
                      _: 2
                    }, 1032, ["name"])
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_ToggleSwitch, {
          model: _ctx.vistaCompacta,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeViewMode()))
        }, null, 8, ["model"]),
        _cache[6] || (_cache[6] = _createTextVNode(" Vista compacta "))
      ]),
      (_ctx.tipo.id==1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_DataView, {
              value: _ctx.empresasFiltradas,
              paginator: "",
              rows: 20,
              alwaysShowPaginator: false,
              dataKey: "item.id"
            }, {
              empty: _withCtx(() => _cache[7] || (_cache[7] = [
                _createElementVNode("div", { class: "w-full flex flex-row items-center justify-center px-5 py-5 text-2xl font-semibold text-center text-gray-500" }, " No hay expositores ", -1)
              ])),
              list: _withCtx((slotProps) => [
                (_ctx.vistaCompacta)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slotProps.items, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: "w-full md:w-1/2 lg:w-1/4 px-1 pb-2"
                          }, [
                            _createElementVNode("div", _hoisted_9, [
                              _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("div", _hoisted_11, [
                                  _createElementVNode("img", {
                                    src: item.previewLogo,
                                    class: _normalizeClass([_ctx.fitClass, "w-full h-full object-center"]),
                                    onLoad: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onImageLoad && _ctx.onImageLoad(...args)))
                                  }, null, 42, _hoisted_12)
                                ]),
                                _createElementVNode("div", _hoisted_13, [
                                  _createElementVNode("div", _hoisted_14, _toDisplayString(item.nombreFantasia), 1),
                                  _createElementVNode("div", _hoisted_15, [
                                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'phone'] }),
                                    _createTextVNode(" " + _toDisplayString(item.telefono), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_16, [
                                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'location-dot'] }),
                                    _createTextVNode(" " + _toDisplayString(item.domicilio), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_17, [
                                    _createVNode(_component_font_awesome_icon, { icon: ['far', 'envelope'] }),
                                    _createTextVNode(" " + _toDisplayString(item.mailComercial), 1)
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", {
                                onClick: ($event: any) => (_ctx.mostrarDetalleEmpresa(item)),
                                class: "absolute inset-0 bg-black bg-opacity-60 flex flex-col items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-lg cursor-pointer"
                              }, [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: ['fas', 'search'],
                                  class: "text-white text-2xl mb-1"
                                }),
                                _cache[8] || (_cache[8] = _createElementVNode("span", { class: "text-white text-sm font-semibold" }, "MAS INFORMACIÓN", -1))
                              ], 8, _hoisted_18)
                            ])
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.vistaCompacta)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slotProps.items, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", { key: index }, [
                            _createElementVNode("div", _hoisted_21, [
                              _createElementVNode("div", _hoisted_22, [
                                _createElementVNode("div", _hoisted_23, [
                                  _createElementVNode("img", {
                                    src: item.previewLogo,
                                    class: _normalizeClass([_ctx.fitClass, "w-full h-full object-center"]),
                                    onLoad: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onImageLoad && _ctx.onImageLoad(...args)))
                                  }, null, 42, _hoisted_24)
                                ]),
                                _createElementVNode("div", _hoisted_25, [
                                  _createElementVNode("div", _hoisted_26, _toDisplayString(item.nombreFantasia), 1),
                                  _createElementVNode("div", _hoisted_27, [
                                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'phone'] }),
                                    _createTextVNode(" " + _toDisplayString(item.telefono), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_28, [
                                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'location-dot'] }),
                                    _createTextVNode(" " + _toDisplayString(item.domicilio), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_29, " Stand : " + _toDisplayString(item.stand), 1),
                                  _createElementVNode("div", _hoisted_30, [
                                    _createVNode(_component_font_awesome_icon, { icon: ['far', 'envelope'] }),
                                    _createTextVNode(" " + _toDisplayString(item.mailComercial), 1)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_31, [
                                  _createElementVNode("a", {
                                    onClick: ($event: any) => (_ctx.mostrarDetalleEmpresa(item)),
                                    class: "py-1 mt-2 block rounded border border-black bg-transparent text-black hover:bg-black hover:text-white cursor-pointer"
                                  }, [
                                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'plus'] }),
                                    _cache[9] || (_cache[9] = _createTextVNode(" MAS INFORMACIÓN "))
                                  ], 8, _hoisted_32)
                                ])
                              ])
                            ])
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["value"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.tipo.id==2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
            _createVNode(_component_DataView, {
              value: _ctx.productosFiltrados,
              paginator: "",
              rows: 16,
              alwaysShowPaginator: false,
              dataKey: "item.id"
            }, {
              empty: _withCtx(() => _cache[10] || (_cache[10] = [
                _createElementVNode("div", { class: "w-full flex flex-row items-center justify-center px-5 py-5 text-2xl font-semibold text-center text-gray-500" }, " No hay productos ", -1)
              ])),
              list: _withCtx((slotProps) => [
                (_ctx.vistaCompacta)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slotProps.items, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: "w-full md:w-1/2 lg:w-1/4 px-1 pb-2"
                          }, [
                            _createElementVNode("div", _hoisted_36, [
                              _createElementVNode("div", _hoisted_37, [
                                _createElementVNode("div", _hoisted_38, [
                                  _createElementVNode("img", {
                                    src: item.previewFotoFile,
                                    class: "w-full h-full object-cover object-center"
                                  }, null, 8, _hoisted_39)
                                ]),
                                _createElementVNode("div", _hoisted_40, [
                                  _createElementVNode("div", _hoisted_41, _toDisplayString(item.descripcion), 1),
                                  _createElementVNode("div", _hoisted_42, _toDisplayString(item.detalles), 1)
                                ])
                              ]),
                              _createElementVNode("div", {
                                onClick: ($event: any) => (_ctx.mostrarDetalleEmpresa(item.empresa)),
                                class: "absolute inset-0 bg-black bg-opacity-60 flex flex-col items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-lg cursor-pointer"
                              }, [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: ['fas', 'search'],
                                  class: "text-white text-2xl mb-1"
                                }),
                                _cache[11] || (_cache[11] = _createElementVNode("span", { class: "text-white text-sm font-semibold" }, "MAS INFORMACIÓN", -1))
                              ], 8, _hoisted_43)
                            ])
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.vistaCompacta)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                      _createElementVNode("div", _hoisted_45, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slotProps.items, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", { key: index }, [
                            _createElementVNode("div", _hoisted_46, [
                              _createElementVNode("div", _hoisted_47, [
                                _createElementVNode("div", _hoisted_48, [
                                  _createElementVNode("img", {
                                    src: item.previewFotoFile,
                                    class: "w-full h-full object-cover object-center"
                                  }, null, 8, _hoisted_49)
                                ]),
                                _createElementVNode("div", _hoisted_50, [
                                  _createElementVNode("div", _hoisted_51, _toDisplayString(item.descripcion), 1),
                                  _createElementVNode("div", _hoisted_52, _toDisplayString(item.detalles), 1)
                                ]),
                                _createElementVNode("div", _hoisted_53, [
                                  _createElementVNode("a", {
                                    onClick: ($event: any) => (_ctx.mostrarDetalleEmpresa(item.empresa)),
                                    class: "py-1 mt-2 block rounded border border-black bg-transparent text-black hover:bg-black hover:text-white cursor-pointer"
                                  }, [
                                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'plus'] }),
                                    _cache[12] || (_cache[12] = _createTextVNode(" MAS INFORMACIÓN "))
                                  ], 8, _hoisted_54)
                                ])
                              ])
                            ])
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["value"])
          ]))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode(_component_BlockUI, {
      blocked: _ctx.isSubmitting,
      fullScreen: ""
    }, null, 8, ["blocked"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.masInformacionVisible,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.masInformacionVisible) = $event)),
      modal: "",
      header: _ctx.empresaSeleccionada?.nombreFantasia,
      class: "w-[90%] lg:w-[60%]"
    }, {
      default: _withCtx(() => [
        (_ctx.empresaSeleccionada)
          ? (_openBlock(), _createBlock(_component_CatalogoDetalleView, {
              key: 0,
              empresa: _ctx.empresaSeleccionada,
              closeFunction: _ctx.closeDialog
            }, null, 8, ["empresa", "closeFunction"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible", "header"])
  ], 64))
}